import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import handleAddToCart from "./addtocartfunction"; // Import the add to cart function
const RecommendedOne = () => {
  const [categories, setCategories] = useState([]);
  const [productsByCat, setProductsByCat] = useState({});
  const [activeTab, setActiveTab] = useState("all");

  const WC_URL = process.env.REACT_APP_WC_URL;
  const CK = process.env.REACT_APP_WC_CK;
  const CS = process.env.REACT_APP_WC_CS;

  // 1️⃣ Fetch all categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/recommended-categories/`
        );

        const data = await res.json();

        if (data.status) {
          setCategories(data.data);
        } else {
          console.error("Category fetch failed", data.error);
        }
      } catch (err) {
        console.error("Category fetch error:", err);
      }
    };

    fetchCategories();
  }, []);
  // 2️⃣ Fetch products for each subcategory of Recommended
  useEffect(() => {
    const fetchRecommended = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/recommended-products/`
        );

        const data = await res.json();

        if (data.status) {
          setProductsByCat(data.data);
        } else {
          console.error("Recommended fetch failed", data.error);
        }
      } catch (err) {
        console.error("Recommended API error:", err);
      }
    };

    fetchRecommended();
  }, []);

  const parentCat = categories.find(c => c.slug === "recommended-for-you");
  const subCategories = categories.filter(c => c.parent === parentCat?.id);

  return (
    <section className="recommended">
      <div className="container container-lg">

        {/* Heading + Tabs */}
        <div className="section-heading flex-between flex-wrap gap-16">
          <h5 className="mb-0">Recommended for you</h5>
          <ul className="nav common-tab nav-pills">

            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "all" ? "active" : ""}`}
                onClick={() => setActiveTab("all")}
              >
                All
              </button>
            </li>

            {subCategories.map(cat => (
              <li className="nav-item" key={cat.id}>
                <button
                  className={`nav-link ${activeTab === cat.slug ? "active" : ""}`}
                  onClick={() => setActiveTab(cat.slug)}
                >
                  {cat.name}
                </button>
              </li>
            ))}

          </ul>
        </div>

        {/* Products */}
        <div className="tab-content">

          {/* All */}
          {activeTab === "all" && (
            <div className="row g-12">
              {Object.values(productsByCat).flat().slice(0, 12).map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}

          {/* Subcategories */}
          {subCategories.map(cat => (
            activeTab === cat.slug && (
              <div className="row g-12" key={cat.slug}>
                {(productsByCat[cat.slug] || []).map(product => (
                  <ProductCard key={product.id} product={product} />
                ))}
              </div>
            )
          ))}

        </div>
      </div>
    </section>
  );
};

// 🔹 Reusable Card Component
const ProductCard = ({ product }) => (
  <div className="col-xxl-2 col-lg-3 col-sm-4 col-6">
    <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">

      {product.on_sale && (
        <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
          Sale {Math.round(((product.regular_price - product.sale_price) / product.regular_price) * 100)}%
        </span>
      )}

      <Link to={`/product-details/${product.id}`} className="product-card__thumb flex-center">
        <img
          src={product.images?.[0]?.src || "assets/images/thumbs/placeholder.png"}
          alt={product.name}
        />
      </Link>

      <div className="product-card__content p-sm-2">

        <div className="flex-align gap-6">
          <span className="text-xs fw-bold text-gray-500">
            {product.average_rating || "0.0"}
          </span>
          <span className="text-15 fw-bold text-warning-600 d-flex">
            <i className="ph-fill ph-star" />
          </span>
          <span className="text-xs fw-bold text-gray-500">
            ({product.rating_count || 0})
          </span>
        </div>
        <h6 className="title text-lg fw-semibold mt-12 mb-8">
          <Link to="/product-details" className="link text-line-2">
            {product.name}
          </Link>
        </h6>

        <div className="flex-align gap-4">
          <span className="text-main-600 text-md d-flex">
            <i className="ph-fill ph-storefront" />
          </span>
          <span className="text-gray-500 text-xs">
            By {product.store?.name || "Store"}
          </span>
        </div>



        <div className="product-card__content mt-12">
          <div className="product-card__price mb-8">
            <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
              ₹{product.regular_price}
            </span>
            {product.regular_price && (
              <span className="text-heading text-md fw-semibold">
                ₹{product.sale_price || product.price}
                <span className="text-gray-500 fw-normal"> /Qty</span>
              </span>
            )}
          </div>

          <button
            onClick={() => handleAddToCart(product.id)}
            className="product-card__cart btn btn-main py-11 px-24 rounded-pill flex-align gap-8"
          >
            Add To Cart <i className="ph ph-shopping-cart" />
          </button>
        </div>


      </div>
    </div>
  </div>
);

export default RecommendedOne;
